<template>
    <div>
<!--        <overlay :close-button-offset-y="innerWidth <= 599 ? '45' : '55'" close-button-offset-x="30"-->
<!--                 overlayOffsetX="0"-->
<!--                 v-model="showMobileMenuOverlay"-->
<!--        >-->
<!--            <mobile-menu @hide="showMobileMenuOverlay = $event"></mobile-menu>-->
<!--        </overlay>-->
<!--        <btn @click="showMobileMenuOverlay = true"-->
<!--             class="absolute nav-menu"-->
<!--             v-if="innerWidth < 950"-->
<!--             icon-->
<!--             v-show="!showMobileMenuOverlay"-->
<!--        >-->
<!--            <icon color="white" icon="text-short"></icon>-->
<!--        </btn>-->
        <row align="center"
             class="text-white"
             justify="space-between"
             no-wrap
             style="top: 46px; width: 960px;"
        >
            <img @click="$router.replace('/')"
                 alt="fitt_light"
                 class="home-page-main-logo cursor-pointer mr-16"
                 src="@/assets/logos/fitt_light.png"
            >
            <div class="flex flex-row justify-between w-full nav-items" v-if="innerWidth > 1024">
                <tw-menu bottom>
                    <template v-slot:activator="{ on }">
                        <btn :ripple="false" class="poppins-bold tracking-wide leading-tight" flat height="20"
                             no-padding
                             tile v-on="on">
                            Why Fitt?
                        </btn>
                    </template>
                    <tw-list class="px-6">
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/customizations">Customizations</router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/dispersing-notions">Dispersing Notions
                            </router-link>
                        </tw-list-item>
                        <!--                        <tw-list-item-->
                        <!--                            @click="goToUseCases()"-->
                        <!--                            class="tracking-normal leading-relaxed poppins-medium"-->
                        <!--                        >-->
                        <!--                            Use cases-->
                        <!--                        </tw-list-item>-->
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/university-of-cambridge">Cambridge</router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/languages">Languages</router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/reporting">Reporting</router-link>
                        </tw-list-item>
                        <tw-list-item
                            class="tracking-normal leading-relaxed poppins-medium"
                        >
                            <router-link active-class="text-primary" to="/applications">Applications</router-link>
                        </tw-list-item>
                    </tw-list>
                </tw-menu>
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Platform-->
                <!--                </btn>-->
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Pricing-->
                <!--                </btn>-->
<!--                <btn :ripple="false"-->
<!--                     @click="$router.push('/case-studies')"-->
<!--                     class="poppins-bold tracking-wide leading-tight"-->
<!--                     flat-->
<!--                     height="20"-->
<!--                     no-padding-->
<!--                     tile-->
<!--                >Case Studies-->
<!--                </btn>-->
                <router-link class="poppins-bold tracking-wide leading-tight uppercase"
                             active-class="text-accent"
                             to="/case-studies"
                >Case Studies
                </router-link>
                <router-link class="poppins-bold tracking-wide leading-tight uppercase"
                             active-class="text-accent"
                             to="/get-fitt"
                >Get Fitt
                </router-link>
                <!--                <btn flat :ripple="false" class="poppins-bold tracking-wide leading-tight" no-padding tile height="20">-->
                <!--                    Get Fitt-->
                <!--                </btn>-->
<!--                <btn :ripple="false" @click="$navigate('https://manage.fitt.ai/')"-->
<!--                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding-->
<!--                     tile>-->
<!--                    Log In-->
<!--                </btn>-->
<!--                <router-link class="poppins-bold tracking-wide leading-tight uppercase"-->
<!--                             active-class="text-accent"-->
<!--                             to="/ebook"-->
<!--                >EBOOKs-->
<!--                </router-link>-->
                <btn :ripple="false" @click="$navigate('/ebook')"
                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding
                     tile>
                    EBOOK
                </btn>
                <btn :ripple="false" @click="$navigate('https://journey.fitt.ai/')"
                     class="poppins-bold tracking-wide leading-tight" flat height="20" no-padding
                     tile>
                    Completing a Fitt?
                </btn>
            </div>
        </row>
    </div>
</template>

<script>
    export default {
        name: "NavBar",
        components: {
            // 'mobile-menu': () => import('@/components/page/MobileMenu.vue'),
            // 'overlay': () => import('@/components/Overlay.vue'),
            'btn': () => import('@/components/Btn.vue'),
            // 'icon': () => import('@/components/display/Icon.vue'),
            'tw-menu': () => import('@/components/display/TwMenu.vue'),
            'tw-list': () => import('@/components/List.vue'),
            'tw-list-item': () => import('@/components/ListItem.vue'),
        },
        data: () => ({
            innerWidth: 0,
            showMobileMenuOverlay: false
        }),
        methods: {
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            }
        },
        mounted() {
            window.addEventListener('resize', this.setInnerWidth);
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 599px) {
        /*.nav-menu {*/
        /*    top: 25px;*/
        /*    left: 23px;*/
        /*}*/

        .home-page-main-logo {
            width: 130px;
        }

        /*.nav-items {*/
        /*    display: none;*/
        /*}*/
    }

    @media only screen and (min-width: 600px) and (max-width: 1023px) {
        /*.nav-menu {*/
        /*    top: 55px;*/
        /*    left: 23px;*/
        /*}*/

        /*.home-page-main-logo {*/
        /*    width: 170px;*/
        /*}*/
        /*.nav-bar {*/
        /*    left: 23px;*/
        /*}*/
    }

    @media only screen and (max-width: 1023px) {
        /*.nav-items {*/
        /*    display: none;*/
        /*}*/

        /*.nav-menu {*/
        /*    top: 6px;*/
        /*}*/

        .home-page-main-logo {
            position: absolute;
            left: 70px;
            top: 0;
            width: 130px;
        }
    }

    @media only screen and (min-width: 1024px) and (max-width: 1639px) {
        /*.nav-menu {*/
        /*    display: none;*/
        /*}*/

        .home-page-main-logo {
            width: 170px;
        }

        /*.nav-bar {*/
        /*    left: 23px;*/
        /*}*/
    }

    @media only screen and (min-width: 1640px) {
        /*.nav-bar {*/
        /*    left: 139px;*/
        /*}*/

        .home-page-main-logo {
            width: 170px;
        }

        /*.nav-menu {*/
        /*    display: none;*/
        /*}*/
    }

    /*@media only screen and (min-width: 1024px) {*/
    /*    !*.nav-menu {*!*/
    /*    !*    display: none;*!*/
    /*    !*}*!*/

    /*    .nav-bar {*/
    /*        left: 23px;*/
    /*    }*/

    /*    .home-page-main-logo {*/
    /*        left: 85px;*/
    /*        width: 170px;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 1279px) and (max-width: 1639px) {*/
    /*    !*8.5 rem = reduction in padding for screens below 1500px width*!*/
    /*    .home-page-main-logo {*/
    /*        !*left: calc(165px - 8.5rem);*!*/
    /*        left: 23px;*/
    /*        width: 170px;*/
    /*    }*/

    /*    .nav-bar {*/
    /*        !*left: calc(359px - 8.5rem);*!*/
    /*        left: 23px;*/
    /*    }*/
    /*}*/

    /*@media only screen and (min-width: 1640px) {*/
    /*    .home-page-main-logo {*/
    /*        !*left: calc(257px - 8.5rem);*!*/
    /*        left: 139px;*/
    /*        width: 170px;*/
    /*    }*/
    /*}*/
</style>
